import { BasicCard as Basic } from './BasicCard';
export var Card = {
  Basic: Basic
};